module.exports = "/static/assets/e6ed36fccdd208479cacfbec1a64ac4b.png";